export default "__VITE_ASSET__DtfIaZUt__"